import { $isListNode, ListItemNode, ListNode } from '@lexical/list'
import {
  $convertFromMarkdownString,
  $convertToMarkdownString,
  type ElementTransformer,
  ORDERED_LIST,
  TEXT_FORMAT_TRANSFORMERS,
  UNORDERED_LIST,
} from '@lexical/markdown'
import {
  $createParagraphNode,
  $getRoot,
  $getSelection,
  $insertNodes,
  $isRootNode,
  $setSelection,
} from 'lexical'

export const DOC_CHAT_PROMPT_NODES = [ListNode, ListItemNode]

function withListBoundaries(
  transformer: ElementTransformer
): ElementTransformer {
  return {
    ...transformer,
    export(node, traverseChildren) {
      const markdown = transformer.export(node, traverseChildren)
      if (markdown === null || !$isRootNode(node.getParent())) return markdown
      const previous = node.getPreviousSibling()
      const next = node.getNextSibling()
      const before =
        previous && !$isListNode(previous) && previous.getTextContent()
          ? '\n'
          : ''
      const after = next?.getTextContent() ? '\n' : ''
      return `${before}${markdown}${after}`
    },
  }
}

export const DOC_CHAT_PROMPT_TRANSFORMERS = [
  withListBoundaries(UNORDERED_LIST),
  withListBoundaries(ORDERED_LIST),
  ...TEXT_FORMAT_TRANSFORMERS,
]

export function $importDocChatPrompt(value: string): void {
  $convertFromMarkdownString(
    value,
    DOC_CHAT_PROMPT_TRANSFORMERS,
    undefined,
    true
  )
}

export function $exportDocChatPrompt(): string {
  if (!$getRoot().getTextContent().trim()) return ''
  return $convertToMarkdownString(DOC_CHAT_PROMPT_TRANSFORMERS, undefined, true)
}

export function $pasteDocChatPrompt(value: string): void {
  const selection = $getSelection()?.clone() ?? null
  const container = $createParagraphNode()
  $convertFromMarkdownString(
    value,
    DOC_CHAT_PROMPT_TRANSFORMERS,
    container,
    true
  )
  $setSelection(selection)
  $insertNodes(container.getChildren())
}
